import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'micro-i18n';
import { connect } from 'unistore/preact';
import { actions } from 'actions';
import { HideState, WidgetState } from 'consts';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/intro/Intro.scss';

const Intro = ({ widgetState, bootstrap = {}, config = {} }) => {
  if (!config || !widgetState) {
    return null;
  }
  const { contextualTargetHiddenState } = bootstrap;
  const { position } = config;

  const isTargetAdmin = widgetState === WidgetState.TargetAdmin;
  const isBlacklistAdmin = widgetState === WidgetState.BlacklistAdmin;
  const isQuestionAdmin = widgetState === WidgetState.QuestionAdmin;
  const isEmpty = widgetState === WidgetState.QuestionsNone;
  const isRespondent = !isTargetAdmin && !isQuestionAdmin;

  const reloadParent = () => {
    parent.location.reload(true);
  };

  const IntroReloadButton = () => {
    return <div className="csw-btns csw-stretch">
      <button type="button" role="button" className="csw-btn outline"
              onClick={reloadParent}>Refresh this page
      </button>
    </div>;
  };

  //Note: We use static english for Admin related text.
  return (
    <section className="csw-intro">
      {isTargetAdmin && <div className="csw-intro-target-admin">
        <div className="h2 h-trim" role="heading" aria-level="1">
          Configure Polling Widget
        </div>
        <div className="csw-intro-detail">
          <p>You can see this polling widget because you are one of its administrators.
            Regular visitors will not see this until it is configured.</p>
        </div>

        {contextualTargetHiddenState === HideState.AdminPosition
        && <div className="csw-intro-target-admin-position">
          {position ? <div className="csw-intro-detail">
              <p>Use the gear icon in the bottom right corner to proceed with the configuration, and then...</p>
            </div> :
            <div className="csw-intro-detail">
              <p><strong>A successful position could not be found</strong>,
                use the position icon in the upper right to proceed with
                configuration, and then...</p>
            </div>}
          <IntroReloadButton/>
        </div>}
      </div>}

      {isBlacklistAdmin && <div className="csw-intro-target-admin">
        <div className="h2 h-trim" role="heading" aria-level="1">
          Hidden Polling Widget
        </div>
        <div className="csw-intro-detail">
          <p>You can see this polling widget because you are one of its administrators.
            Regular visitors may not see it in this page due to it containing blacklisted HTML
            elements defined in the target configuration.</p>
        </div>

        <IntroReloadButton/>
      </div>}

      {isQuestionAdmin && <div className="csw-intro-question-admin">
        <div className="h2 h-trim" role="heading" aria-level="1">
          Ask a Question
        </div>

        <div className="csw-intro-detail">
          <p>You can see this polling widget because you are its administrator.
            Regular visitors will not see this widget until a question is asked.</p>

          <p>Use the gear icon in the bottom right corner to ask a page-level question, and then...</p>
        </div>

        <IntroReloadButton/>
      </div>}

      {isRespondent && isEmpty && <div className="csw-intro-empty">
        <div className="h2 h-trim" role="heading" aria-level="1">
          {i18n.t('OPINION_EXPERT')}
        </div>
        <div className="csw-intro-detail">
          <p>{i18n.t('NO_MORE_QUESTIONS_EXPLANATION')}</p>
        </div>
      </div>}

    </section>
  );
};

Intro.propTypes /* remove-proptypes */ = {
  bootstrap: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  widgetState: PropTypes.number.isRequired
};

export default connect(
  'bootstrap,config,widgetState',
  actions
)(Intro);
